import { CreateWidgetsMap } from "../types/WidgetModule";
import { defineCustomElement } from "./defineCustomElement";

export async function loadClientWidgets<
  T extends Record<string, () => Promise<any>>,
>(widgets: CreateWidgetsMap<T>) {
  Object.entries(widgets).forEach(async ([tag, module]) => {
    if (document.querySelector(tag)) {
      try {
        const widget = await module();
        if (!widget.disableClientRender) {
          defineCustomElement({
            tag,
            Component: widget.default,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  });
}
